/* EyvaX waitlist: form validation, hand tabs, Vegas skyline draw-in. */
(function () {
  'use strict';
  var Eyvax = window.Eyvax;
  if (!Eyvax) return;

  function EyvaxWaitlist() {
    return Reflect.construct(Eyvax.Section, [], EyvaxWaitlist);
  }
  EyvaxWaitlist.prototype = Object.create(Eyvax.Section.prototype);
  EyvaxWaitlist.prototype.constructor = EyvaxWaitlist;

  EyvaxWaitlist.prototype.init = function () {
    var self = this;
    this.bindForm();
    this.bindHand();
    this.bindVegas();
    this.bindCesLinks();
  };

  EyvaxWaitlist.prototype.bindForm = function () {
    var form = this.querySelector('form');
    var status = this.querySelector('[data-role="status"]');
    var result = this.querySelector('[data-role="success"], [data-role="server-error"]');
    if (result && !Eyvax.designMode && /customer_posted|contact_posted|form_type/.test(window.location.search + window.location.hash)) {
      result.focus();
    }
    if (!form || !status) return;

    var email = form.querySelector('input[type="email"]');
    var name = form.querySelector('input[name="contact[first_name]"]');
    var hp = form.querySelector('[data-role="hp"]');
    var say = function (msg, err) {
      status.textContent = msg || '';
      status.classList.toggle('is-err', !!err);
      status.classList.toggle('is-ok', !err && !!msg);
    };

    form.addEventListener(
      'submit',
      function (e) {
        say('');
        if (email) email.removeAttribute('aria-invalid');
        if (hp && hp.value) {
          e.preventDefault();
          return;
        }
        if (name && name.required && !name.value.trim()) {
          e.preventDefault();
          say(status.getAttribute('data-msg-name'), true);
          name.focus();
          return;
        }
        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email.value.trim())) {
          e.preventDefault();
          if (email) {
            email.setAttribute('aria-invalid', 'true');
            email.focus();
          }
          say(status.getAttribute('data-msg-email'), true);
          form.classList.remove('is-shake');
          void form.offsetWidth;
          form.classList.add('is-shake');
          return;
        }
        form.classList.add('is-busy');
        say(status.getAttribute('data-msg-busy'), false);
      },
      { signal: this.signal }
    );

    if (email) {
      email.addEventListener(
        'input',
        function () {
          if (email.getAttribute('aria-invalid') === 'true' && /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email.value.trim())) {
            email.removeAttribute('aria-invalid');
            say('');
          }
        },
        { signal: this.signal }
      );
    }

    // Measure button width for desktop field max-width (--bw)
    var row = form.querySelector('.ex-wl__row');
    var btn = form.querySelector('[data-role="submit"]');
    var measure = function () {
      if (row && btn) row.style.setProperty('--bw', btn.offsetWidth + 'px');
    };
    measure();
    window.addEventListener('resize', measure, { signal: this.signal });
  };

  EyvaxWaitlist.prototype.bindCesLinks = function () {
    var ces = this.querySelector('[data-role="ces"]');
    var email = this.querySelector('input[type="email"]');
    var status = this.querySelector('[data-role="status"]');
    if (!ces) return;
    Eyvax.$$('[data-ces]').forEach(function (a) {
      a.addEventListener(
        'click',
        function () {
          ces.value = 'yes';
          if (status) {
            status.classList.remove('is-ok', 'is-err');
            status.textContent = "Attending CES 2027? Leave your email and we'll invite you to see EyvaX at the show.";
          }
          if (email) {
            email.removeAttribute('aria-invalid');
            setTimeout(function () {
              email.focus({ preventScroll: true });
            }, 0);
          }
        },
        { signal: this.signal }
      );
    }, this);
  };

  EyvaxWaitlist.prototype.bindHand = function () {
    var self = this;
    var tabs = Eyvax.$$('.ex-wl__tabs [role="tab"]', this);
    var shots = Eyvax.$$('.ex-wl__screen', this);
    var stage = this.querySelector('[data-role="hand"]');
    var pill = this.querySelector('[data-role="ind"]');
    if (!tabs.length || !stage || !shots.length) return;

    var at = parseInt(this.getAttribute('data-default'), 10);
    if (isNaN(at) || at < 0 || at >= tabs.length) {
      at = tabs.map(function (t) {
        return t.getAttribute('aria-selected');
      }).indexOf('true');
      if (at < 0) at = 0;
    }
    this.at = at;
    this.chosen = false;
    this.tabs = tabs;
    this.shots = shots;
    this.pill = pill;

    var place = function () {
      if (!pill || !tabs[self.at]) return;
      pill.style.setProperty('--ix', tabs[self.at].offsetLeft - 4 + 'px');
      pill.style.setProperty('--iw', tabs[self.at].offsetWidth + 'px');
    };
    this.placeInd = place;

    tabs.forEach(function (t, i) {
      t.addEventListener(
        'click',
        function () {
          self.chosen = true;
          if (self.timer) clearInterval(self.timer);
          self.go(i);
        },
        { signal: self.signal }
      );
      t.addEventListener(
        'keydown',
        function (e) {
          var n = e.key === 'ArrowRight' ? (i + 1) % tabs.length : e.key === 'ArrowLeft' ? (i + tabs.length - 1) % tabs.length : -1;
          if (n < 0) return;
          e.preventDefault();
          tabs[n].focus();
          tabs[n].click();
        },
        { signal: self.signal }
      );
    });

    this.go(at);
    window.addEventListener('resize', place, { signal: this.signal });

    if (this.getAttribute('data-autoplay') !== 'true' || Eyvax.reduced() || !('IntersectionObserver' in window)) return;

    var interval = parseInt(this.getAttribute('data-interval'), 10) || 3200;
    new IntersectionObserver(
      function (es) {
        es.forEach(function (e) {
          if (self.timer) clearInterval(self.timer);
          if (e.isIntersecting && !self.chosen) {
            self.timer = setInterval(function () {
              self.go((self.at + 1) % tabs.length);
            }, interval);
          }
        });
      },
      { threshold: 0.4 }
    ).observe(stage);
  };

  EyvaxWaitlist.prototype.go = function (i) {
    this.at = i;
    var key = this.tabs[i] ? this.tabs[i].getAttribute('data-shot') : null;
    this.tabs.forEach(function (t, k) {
      var on = k === i;
      t.setAttribute('aria-selected', String(on));
      t.tabIndex = on ? 0 : -1;
    });
    this.shots.forEach(function (im) {
      im.classList.toggle('is-on', im.getAttribute('data-shot') === key);
    });
    if (this.placeInd) this.placeInd();
  };

  EyvaxWaitlist.prototype.bindVegas = function () {
    var vegas = this.sectionEl.querySelector('[data-role="vegas"]');
    if (!vegas || Eyvax.reduced()) return;
    vegas.classList.add('is-pre');
    var go = function () {
      requestAnimationFrame(function () {
        vegas.classList.remove('is-pre');
      });
    };
    if (!('IntersectionObserver' in window)) {
      go();
      return;
    }
    var io = new IntersectionObserver(
      function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) {
            go();
            io.unobserve(e.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.15 }
    );
    io.observe(vegas);
    this.signal.addEventListener('abort', function () {
      io.disconnect();
    });
  };

  EyvaxWaitlist.prototype.activateBlock = function (blockId) {
    var i = Eyvax.blockIndex(this.shots || [], blockId);
    if (i < 0 && this.tabs) i = Eyvax.blockIndex(this.tabs, blockId);
    if (i > -1) {
      this.chosen = true;
      if (this.timer) clearInterval(this.timer);
      this.go(i);
    }
  };

  EyvaxWaitlist.prototype.destroy = function () {
    if (this.timer) clearInterval(this.timer);
  };

  Eyvax.define('eyvax-waitlist', EyvaxWaitlist);
})();
